import i18n from 'i18next';
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';

import languages from './locales/index';
 
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: languages,
//    lng: "pt",
    fallbackLng: ['en', 'pt'],
    debug: true,
 
    // have a common namespace used around the full app
    //ns: ['translations'],
    //defaultNS: 'translations',
    defaultNS: 'app',
    fallbackNS: 'common',
 
    // allow an empty value to count as invalid (by default is true)
    returnEmptyString: false,

    interpolation: {
      escapeValue: false, // not needed for react??
      formatSeparator: ',',
      /*format: (value, format) => {
        if (value instanceof Date) return moment(value).format(format);
        return value;
      }*/
    },
 
    react: {
      wait: true
    }
  });
 
export default i18n;


// WEBPACK FOOTER //
// ./src/i18n.js